var map = {
	"./amex.png": 938,
	"./diners.png": 939,
	"./discover.png": 940,
	"./jcb.png": 941,
	"./maestro.png": 1164,
	"./mastercard.png": 942,
	"./stripe.png": 943,
	"./union.png": 944,
	"./unknown.png": 621,
	"./visa.png": 945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1163;